import React, { Component } from 'react';
import { AudioPlayer } from "react-audio-play";
import { UsersService } from '../../services/user';
import './ia-bot.css';
import './ia-bot-reading-list.css';

class IaBotReadingList extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      renderAiBot: true,
      aiThread: [],
      activeFormat: "reading-list",
      loadingAi: true,
      suggestions: null,
      readingListSuggestions: []
    };

    // Bind dos métodos
    this.onSuggestionClick = this.onSuggestionClick.bind(this);
    this.onSubmitIaText = this.onSubmitIaText.bind(this);
    this.iaThreadScrollToBottom = this.iaThreadScrollToBottom.bind(this);
    this.arrayBufferToBase64 = this.arrayBufferToBase64.bind(this);
    this.sanitizeTextForTTS = this.sanitizeTextForTTS.bind(this);
    this.getTextToSpeech = this.getTextToSpeech.bind(this);
    this.setRenderAiBot = this.setRenderAiBot.bind(this);
    this.setActiveFormat = this.setActiveFormat.bind(this);
    this.generateReadingListSuggestions = this.generateReadingListSuggestions.bind(this);
    this.onReadingListSuggestionClick = this.onReadingListSuggestionClick.bind(this);
    this.getImageUrl = this.getImageUrl.bind(this);
  }

  componentDidMount() {
    // Gera sugestões de listas de leitura baseadas nos dados fornecidos
    if (this.props.booksData && this.props.apiContext) {
      this.generateReadingListSuggestions();
    }
  }

  componentDidUpdate(prevProps) {
    // Atualiza sugestões quando os dados de livros mudam
    if (prevProps.booksData !== this.props.booksData && this.props.booksData) {
      if (this.props.apiContext) {
        this.generateReadingListSuggestions();
      }
    }
  }

  setRenderAiBot(value) {
    this.setState({ renderAiBot: value });
  }

  setActiveFormat(format) {
    this.setState({ activeFormat: format });
  }

  getImageUrl(uid) {
    const { apiContext } = this.props;
    
    if (!uid || !apiContext) {
      return null;
    }

    // Usando UsersService para obter o token para as imagens
    const accessToken = UsersService.getUser()?.accessToken;

    if (!accessToken) {
      return null;
    }

    const url = `https://${apiContext.domain}/cms/v1.1/managed/content/group/uid/${uid}/default/thumb?image_options=width:200&api_env=${apiContext.api_env}&project_key=${apiContext.project_key}&access_token=${accessToken}`;
    
    return url;
  }

  arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  sanitizeTextForTTS(text) {
    let cleaned = text
      .replace(/[""'']/g, '"')
      .replace(/[^\S\r\n]+/g, ' ')
      .replace(/([.?!])(?=\S)/g, '$1 ')
      .replace(/(?<=\w)\. (?=[A-ZÁÉÍÓÚ])/g, ', ')
      .replace(/(?<=\w)\.(?=\s|$)/g, ',')
      .replace(/,+/g, ',')
      .replace(/,+$/, '')
      .trim();

    cleaned = cleaned.replace(/, ([A-ZÁÉÍÓÚ])/g, (_, letra) => `, ${letra.toLowerCase()}`);
    return cleaned;
  }

  async getTextToSpeech(message) {
    const { apiContext, textToSpeechConnector } = this.props;
    
    if (!textToSpeechConnector) {
      console.warn("Text to speech connector não disponível");
      return null;
    }

    // Token fixo para acesso à API
    const accessToken = this.props.accessToken;

    if (!accessToken) {
      return null;
    }

    const apiUrl = `https://api.digitalpages.com.br/communication/v1.0/tts/connector/uid/${textToSpeechConnector.uid}/convert/audio`;
    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Api-Env": `${apiContext.api_env}`,
        "Project-Key": `${apiContext.project_key}`
      },
      body: JSON.stringify({
        "input": message
      })
    };

    try {
      const response = await fetch(apiUrl, options);
      const arrayBuffer = await response.arrayBuffer();
      const base64String = this.arrayBufferToBase64(arrayBuffer);
      const audioBase64 = `data:audio/mp3;base64,${base64String}`;
      return audioBase64;
    } catch (error) {
      console.error("Erro ao gerar áudio:", error);
      return null;
    }
  }

  async generateReadingListSuggestions() {
    const { apiContext, booksData , aiConnector} = this.props;
    debugger;
    
    if (!apiContext?.domain || !booksData?.result) {
      console.warn("Dados necessários para AI não estão disponíveis");
      return;
    }

    const aiConnectorUid = aiConnector.uid;
    const apiUrl = `https://api.digitalpages.com.br/insights/v1.1/generative/connector/uid/${aiConnectorUid}/response`;

    // Prepara dados dos livros para o prompt
    const booksInfo = booksData.result.slice(0, 10).map(book => ({
      name: book.name,
      description: book.description,
      readingTime: book.properties.find(p => p.name === "Tempo de leitura")?.value || "N/A",
      edition: book.properties.find(p => p.name === "Número da edição")?.value || "N/A"
    }));

    const prompt = `
      Com base no catálogo de livros disponível, gere 4 sugestões inteligentes de listas de leitura temáticas que um usuário pode solicitar. 

      As sugestões devem ser variadas e atrativas, cobrindo diferentes áreas de interesse como:
      - Desenvolvimento profissional
      - Saúde e bem-estar
      - Tecnologia e inovação
      - Gastronomia e culinária
      - Educação e aprendizado
      - Gestão e liderança

      Cada sugestão deve ser uma pergunta clara que o usuário pode fazer para receber uma lista personalizada de livros.

      Retorne no formato JSON:
      {
        "suggestions": [
          {
            "id": "1",
            "text": "Monte uma lista de livros para quem quer se desenvolver profissionalmente",
            "category": "Desenvolvimento Profissional"
          }
        ]
      }

      Catálogo disponível (primeiros 10 livros):
      ${JSON.stringify(booksInfo, null, 2)}
    `;

    // Token fixo para acesso à API
    const accessToken = this.props.accessToken;

    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Api-Env": `${apiContext.api_env}`,
        "Project-Key": `${apiContext.project_key}`
      },
      body: JSON.stringify({
        "prompt": prompt
      })
    };

    try {
      let decoder = new TextDecoder();
      let result = "";

      const response = await fetch(apiUrl, options);

      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.statusText}`);
      }

      const reader = response.body.getReader();

      while (true) {
        const { done, value } = await reader.read();

        result += decoder
              .decode(value, { stream: true })
              .replace(/(\r?\n|\r)/g, "")
              .replace(/\s+/g, " ");

        if (done) {
          const content = JSON.parse(result.replace(/```(?:json)?|```/g, '').trim());
          this.setState({ suggestions: content.suggestions, loadingAi: false });
          break;
        }
      }
    } catch (error) {
      console.error("Erro ao obter sugestões de listas de leitura:", error);
    }
  }

  onSuggestionClick(text) {
    const input = document.getElementById("rdp-composer-ia-input-reading");
    if (input) {
      input.value = text;
      this.onSubmitIaText();
    }
  }

  onReadingListSuggestionClick(book) {
    // Callback para quando um livro da lista sugerida for clicado
    debugger;
    if (this.props.onBookSelect) {
      this.props.onBookSelect(book);
    }
  }

  iaThreadScrollToBottom() {
    setTimeout(() => {
      const target = document.querySelector(".ia-bot-search-chat-thread");
      if (target) {
        target.scrollTo({ top: target.scrollHeight, behavior: "smooth" });
      }
    }, 300);
  }

  async onSubmitIaText() {
    const { apiContext, booksData, aiConnector } = this.props;
    const { activeFormat, aiThread } = this.state;
    
    this.setState({ loadingAi: true });

    const input = document.getElementById("rdp-composer-ia-input-reading");
    const userMessage = input ? input.value : '';

    if (!userMessage.trim()) {
      this.setState({ loadingAi: false });
      return;
    }

    const aiThreadTemp = [...aiThread];
    aiThreadTemp.push({
      "owner": "me",
      "type": "text",
      "content": userMessage
    });
    
    this.setState({ aiThread: aiThreadTemp });
    this.iaThreadScrollToBottom();

    if (input) {
      input.value = "";
    }

    const aiConnectorUid = aiConnector.uid;
    const apiUrl = `https://api.digitalpages.com.br/insights/v1.1/generative/connector/uid/${aiConnectorUid}/response`;

    // Prepara dados completos dos livros para o prompt
    const booksInfo = booksData.result.map(book => ({
      uid: book.uid,
      name: book.name,
      description: book.description,
      properties: book.properties.reduce((acc, prop) => {
        acc[prop.name] = prop.value;
        return acc;
      }, {})
    }));

    let prompt = "";

    if (activeFormat === "text") {
      prompt = `
        Você é um assistente especializado em recomendar listas de leitura personalizadas.

        Com base na solicitação do usuário e no catálogo de livros disponível, crie uma lista de leitura temática com 5-8 livros relevantes.

        Para cada livro recomendado, forneça:
        - Título do livro
        - Breve descrição (2-3 linhas)
        - Tempo de leitura estimado
        - Por que este livro foi incluído na lista

        Organize a resposta em HTML bem formatado com:
        - Título da lista de leitura
        - Introdução explicando o critério de seleção
        - Lista numerada dos livros com as informações solicitadas
        - Conclusão com dicas de como aproveitar melhor a leitura

        Solicitação do usuário: "${userMessage}"

        Catálogo disponível:
        ${JSON.stringify(booksInfo, null, 2)}
      `;
    } else if (activeFormat === "audio") {
      prompt = `
        Você é um assistente especializado em recomendar listas de leitura personalizadas.

        Crie uma resposta em linguagem natural e fluida para áudio, recomendando uma lista de leitura com 5-6 livros baseada na solicitação do usuário.

        Use uma linguagem conversacional, como se estivesse falando com um amigo sobre livros. Inclua:
        - Uma introdução calorosa sobre a lista
        - Recomendações dos livros com explicações do por que são interessantes
        - Dicas de como organizar a leitura

        Evite usar aspas, asteriscos, parênteses ou siglas técnicas.

        Solicitação do usuário: "${userMessage}"

        Catálogo disponível:
        ${JSON.stringify(booksInfo, null, 2)}
      `;
    } else if (activeFormat === "reading-list") {
      prompt = `
        Com base na solicitação do usuário, retorne uma lista estruturada de livros em formato JSON.

        Selecione 5-8 livros mais relevantes do catálogo e retorne no formato:
        {
          "title": "Título da Lista de Leitura",
          "description": "Breve descrição da lista",
          "books": [
            {
              "uid": "uid_do_livro",
              "name": "Nome do livro",
              "description": "Descrição do livro",
              "readingTime": "Tempo de leitura",
              "reason": "Por que este livro está na lista"
            }
          ]
        }

        Retorne apenas o JSON puro, sem markdown ou backticks.

        Solicitação do usuário: "${userMessage}"

        Catálogo disponível:
        ${JSON.stringify(booksInfo, null, 2)}
      `;
    }

    // Token fixo para acesso à API
    const accessToken = this.props.accessToken;

    const options = {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Api-Env": `${apiContext.api_env}`,
        "Project-Key": `${apiContext.project_key}`
      },
      body: JSON.stringify({
        "prompt": prompt
      })
    };

    try {
      let decoder = new TextDecoder();
      let result = "";

      const response = await fetch(apiUrl, options);

      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.statusText}`);
      }

      const reader = response.body.getReader();

      while (true) {
        const { done, value } = await reader.read();

        result += decoder
              .decode(value, { stream: true })
              .replace(/(\r?\n|\r)/g, "")
              .replace(/\s+/g, " ");

        if (done) {
          const temp = [...aiThreadTemp];
          let content;

          if (activeFormat === "text") {
            content = result.replace("```html", "").replace("```", "");
            temp.push({
              "owner": "ai-agent",
              "type": "text",
              "content": content
            });
          } else if (activeFormat === "reading-list") {
            content = JSON.parse(result.replace(/```(?:json)?|```/g, '').trim());
            temp.push({
              "owner": "ai-agent",
              "type": "reading-list",
              "content": content
            });
          } else if (activeFormat === "audio") {
            content = result.replaceAll("*", "").replaceAll("(", "").replaceAll(")", "");
            const audioBase64 = await this.getTextToSpeech(content);

            temp.push({
              "owner": "ai-agent",
              "type": "audio",
              "content": audioBase64
            });
          }

          this.setState({ 
            aiThread: temp,
            loadingAi: false
          });
          this.iaThreadScrollToBottom();
          break;
        }
      }
    } catch (error) {
      console.error("Erro ao processar resposta da IA:", error);
      this.setState({ loadingAi: false });
    }
  }

  render() {
    const { renderAiBot, aiThread, activeFormat, loadingAi, suggestions } = this.state;

    return (
      <div className="ia-bot-search">
        <div className="ia-bot-search-overlay" onClick={() => this.props.onClose()}></div>
        {renderAiBot && (
          <div className="ia-bot-search-chat">
            <div className="ia-bot-search-chat-header">
              <span 
                className="ia-bot-search-chat-header-back" 
                onClick={() => this.props.onClose()}
              >
                Fechar assistente de leitura
              </span>
              {/* <span className="ia-bot-search-chat-header-icon">Assistente de Listas de Leitura</span> */}
            </div>
            
            <div className="ia-bot-search-chat-thread">
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
                <h3 className="ia-bot-search-chat-thread-sugestion-label" style={{margin: 0}}>Sugestões de Busca</h3>
                <button 
                  onClick={() => this.props.onClose()}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    fontSize: '18px',
                    cursor: 'pointer',
                    color: '#5a4d32',
                    padding: '4px 8px'
                  }}
                  title="Fechar"
                >
                  ✕
                </button>
              </div>
              {suggestions && (
                <>
                  
                  {suggestions.map((suggestion, index) => (
                    <div 
                      className="ia-bot-search-chat-thread-sugestion reading-list-suggestion" 
                      key={index} 
                      onClick={() => this.onSuggestionClick(suggestion.text)}
                    >
                      <div className="suggestion-category">{suggestion.category}</div>
                      <div className="suggestion-text">{suggestion.text}</div>
                    </div>
                  ))}
                </>
              )}

              <ul className="ia-bot-search-chat-thread-messages">
                {aiThread.map((message, index) => (
                  <li key={index} className="ia-bot-search-chat-thread-message">
                    {message.type === "text" && (
                      <div 
                        className={`ia-bot-search-chat-thread-message-text ${message.owner}`} 
                        dangerouslySetInnerHTML={{ __html: message.content }}
                      />
                    )}
                    {message.type === "reading-list" && (
                      <div className="ia-bot-search-chat-thread-message-reading-list">
                        <h3>{message.content.title}</h3>
                        <p>{message.content.description}</p>
                        <div className="reading-list-books">
                          {message.content.books.map((book, bookIndex) => {
                            const imageUrl = this.getImageUrl(book.uid);
                            return (
                              <div 
                                key={bookIndex} 
                                className="reading-list-book-item"
                                onClick={() => this.onReadingListSuggestionClick(book)}
                              >
                                <div className="book-item-content">
                                  <div className="book-cover">
                                    {imageUrl ? (
                                      <img 
                                        src={imageUrl} 
                                        alt={`Capa do livro ${book.name}`}
                                        onLoad={(e) => {
                                          e.target.parentElement.classList.add('has-image');
                                        }}
                                        onError={(e) => {
                                          e.target.style.display = 'none';
                                          e.target.parentElement.classList.remove('has-image');
                                        }}
                                      />
                                    ) : null}
                                  </div>
                                  <div className="book-info">
                                    <h4>{book.name}</h4>
                                    <p className="book-description">{book.description}</p>
                                    <div className="book-meta">
                                      <span className="reading-time">⏱️ {book.readingTime}</span>
                                    </div>
                                    <p className="book-reason"><strong>Por que ler:</strong> {book.reason}</p>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    {message.type === "audio" && (
                      <div className="ia-bot-search-chat-thread-message-audio">
                        <AudioPlayer src={message.content} />
                      </div>
                    )}
                  </li>
                ))}
              </ul>

              {loadingAi && (
                <div className="preloader-chat">
                  <div className="skeleton-line short"></div>
                  <div className="skeleton-line"></div>
                  <div className="skeleton-line medium"></div>
                </div>
              )}
            </div>
            
            <div className="ia-bot-search-chat-prompt">
              <div className="ia-bot-search-chat-prompt-tools">
                {/* <button 
                  className={`ia-bot-search-chat-prompt-tool-btn text ${activeFormat === "text" ? "active" : ""}`} 
                  onClick={() => this.setActiveFormat("text")}
                >
                  Lista Detalhada
                </button>
                <button 
                  className={`ia-bot-search-chat-prompt-tool-btn audio ${activeFormat === "audio" ? "active" : ""}`} 
                  onClick={() => this.setActiveFormat("audio")}
                >
                  Recomendação em Áudio
                </button>
                <button 
                  className={`ia-bot-search-chat-prompt-tool-btn reading-list ${activeFormat === "reading-list" ? "active" : ""}`} 
                  onClick={() => this.setActiveFormat("reading-list")}
                >
                  Lista Interativa
                </button> */}
                <button 
                  className="ia-bot-search-chat-prompt-tool-btn-send" 
                  onClick={() => this.onSubmitIaText()}
                />
              </div>
              <textarea 
                className="ia-bot-search-chat-prompt-textarea" 
                id="rdp-composer-ia-input-reading"
                placeholder="Ex: Me sugira uma lista de livros sobre liderança e gestão de pessoas..."
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    this.onSubmitIaText();
                  }
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default IaBotReadingList;
